export const renderFingerprintImage = (imageUrl: string, parentElementId: string): void => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(imageUrl ?? '', 'image/svg+xml');
    const svgEle = doc.querySelector('svg');
    const parentEle = document.getElementById(parentElementId);
    if (svgEle && !parentEle?.hasChildNodes()) {
        parentEle?.appendChild(svgEle);
    }
};

export const getApplicantChipInfo = (matchType: string) => {
    let chipColor: 'success' | 'error' | 'primary' |'warning' |'default' = 'default'; 
    let chipLabel = matchType; 
    let chipVariant: 'filled' | 'outlined' = 'filled'; 

    switch (matchType) {
        case 'strong':
            chipColor = 'success';
            chipLabel = 'Strong Fit';
            chipVariant = 'outlined'; 
        break;
        case 'match':
            chipLabel = 'Fit';
            chipVariant = 'outlined'; 
            chipColor = 'primary';
        break;
        case 'none':
            chipColor = 'warning';
            chipLabel = 'Weak Fit';
            chipVariant = 'outlined'; 
        break;
        case 'distortion':
            chipColor = 'error';
            chipLabel = 'Distortion';
            chipVariant = 'outlined'; 
        break;
        default:
            chipLabel = 'Unknown';
}

    return { chipColor, chipLabel, chipVariant };
};